import { useCallback } from 'react'
import type { AuthPrivilegedAccessEntry } from '@ideon-api/sdk-internal'
import { useAuthServiceClient } from './sdk-client'
import { useSdkList, type ListState } from './use-sdk-list'

export function usePrivilegedAccess(permissionSetKey: string): ListState<AuthPrivilegedAccessEntry> & { reload: () => void } {
  const getClient = useAuthServiceClient()
  // useSdkList resets on fetcher identity, so memoize per key.
  const fetcher = useCallback(
    () => getClient().then((client) => client.auth.getPermissionSetPrivilegedAccess(permissionSetKey)),
    [getClient, permissionSetKey]
  )
  return useSdkList<AuthPrivilegedAccessEntry>(fetcher)
}
